import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import WebFont from 'webfontloader';
import { ListApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';

export const SigningFontModal = ({
    isOpen,
    signatureText,
    confirmCallback,
    cancelCallback,
    defaultSignature = false,
}: {
    isOpen: boolean;
    signatureText: string;
    confirmCallback: (x: ListApi.IListItem | undefined) => void;
    cancelCallback: () => void;
    defaultSignature: boolean;
}) => {
    const listApi = new ListApi.ListApi(applicationInsights);

    const [googleFonts, set_googleFonts] = React.useState<ListApi.IListItem[]>();
    const [selectedFont, set_selectedFont] = React.useState<ListApi.IListItem | undefined>();

    React.useEffect(() => {
        _loadGoogleFonts();
    }, []);

    const _loadGoogleFonts = async () => {
        const fonts = await listApi.getGoogleFonts();
        set_googleFonts(fonts);

        const fontNames = fonts.map((font) => font.name);
        WebFont.load({
            google: {
                families: fontNames,
            },
        });
        if (defaultSignature && fonts) {
            confirmCallback(fonts[0]);
        }
    };

    const _handleConfirm = () => confirmCallback(selectedFont);
    const _handleCancel = () => cancelCallback();

    const styles = {
        buttonMarginRight: {
            marginRight: '20px',
        },
        buttonDiv: {
            paddingTop: 20,
            paddingRight: 10,
            paddingBottom: 0,
            paddingLeft: 10,
        },
        radioLabel: {
            fontSize: 24,
        },
        h1Width: {
            flex: 'none',
            maxWidth: 'none',
        },
        noPadding: {
            padding: 0,
        },
        modal: {
            width: 400,
        },
        autoHeight: {
            height: 'auto',
        },
    };
    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={_handleCancel}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1 style={styles.h1Width}>Please select your signature</h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={_handleCancel}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='main-content no-search'>
                            <div
                                className='scrollable-content'
                                style={styles.autoHeight}
                            >
                                <div className='standard-form'>
                                    <div className='row'>
                                        <div className='columns small-12'>
                                            {googleFonts &&
                                                googleFonts.map((font) => {
                                                    const style = {
                                                        ...styles.radioLabel,
                                                        fontFamily: font.name,
                                                    };
                                                    return (
                                                        <div
                                                            className='radio'
                                                            key={font.key}
                                                        >
                                                            <label style={style}>
                                                                <input
                                                                    type='radio'
                                                                    value={font.key}
                                                                    checked={selectedFont?.key === font.key}
                                                                    onChange={(event) => {
                                                                        set_selectedFont(
                                                                            googleFonts.find((g) => g.key === event.target.value)
                                                                        );
                                                                    }}
                                                                />
                                                                {signatureText}
                                                            </label>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                                <div className='button-footer'>
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='submit'
                                        className='button primary'
                                        disabled={selectedFont === undefined}
                                        onClick={_handleConfirm}
                                    >
                                        Sign
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        data-dismiss='modal'
                                        onClick={_handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};
